import Prime from "./Prime";

function App() {
  return (
    <div className="w-full min-h-screen bg-bodyColor text-lightText font-bodyFont relative selection:bg-designColor selection:text-white">
      <div className="fixed inset-0 z-0 bg-gradient-to-br from-[#0F1729] via-[#0d1f3c] to-[#050a15] pointer-events-none" />
      <div className="relative z-10">
        <Prime />
      </div>
    </div>
  );
}

export default App;
